import { FC, useState } from 'react';
import { useDispatch } from 'react-redux';

import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { SelectList } from '$uikit/SelectList/SelectList';
import { Button } from '$uikit';
import { mainActions } from '$store/main';
import { IcMir56, IcVisa56, IcMastercard56, IcBankCard28 } from '$assets';
import { useTranslator } from '$hooks';

interface Card {
  id: number;
  brand: string;
  last4: string;
  active: boolean;
}

interface CardSelectSheetProps {
  cards: Card[];
  initialCardId: number;
  onConfirm: (cardId: number) => void;
}

const brandIcon = (brand: string) => {
  switch (brand.toLowerCase()) {
    case 'mir':
      return <IcMir56 />;
    case 'visa':
      return <IcVisa56 />;
    case 'mastercard':
      return <IcMastercard56 />;
    default:
      return <IcBankCard28 />;
  }
};

export const CardSelectSheet: FC<CardSelectSheetProps> = ({
  cards,
  initialCardId,
  onConfirm,
}) => {
  const dispatch = useDispatch();
  const t = useTranslator();
  const [selectedCardId, setSelectedCardId] = useState<number>(initialCardId);

  const handleClose = () => {
    dispatch(mainActions.setPopup(null));
  };

  const handleConfirm = () => {
    handleClose();
    onConfirm(selectedCardId);
  };

  const options = cards.map((card) => ({
    label: `•••• ${card.last4 || '****'}`,
    value: card.id,
  }));

  return (
    <BottomSheet title={t('top_up_balance_saved_cards_title')} onClose={handleClose}>
      <div style={{ padding: '16px' }}>
        <SelectList
          value={[selectedCardId]}
          options={options}
          onChange={(values) => setSelectedCardId(values[0] as number)}
          getIcon={(option) => {
            const card = cards.find((c) => c.id === option.value);
            return card ? brandIcon(card.brand) : <IcBankCard28 />;
          }}
          iconSize="large"
        />
        <Button stretched onClick={handleConfirm} style={{ marginTop: 16 }}>
          {t('top_up_balance_pay_btn')}
        </Button>
      </div>
    </BottomSheet>
  );
};
